import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/costs/actions';
import GetCosts from './components';
import _ from 'lodash';

const mapStateToProps = state => {
  const { selectedObjectName, selectedObjectType, object } = state.object;
  const { costs, isloading } = state.costs;
  return {
    selectedObjectType,
    object, 
    initialValues: {
      object_length: `${_.get(object, 'object_length_m') || 0} m`,
      object_width: `${_.get(object, 'object_width_m') || 0} m`,
      object_size: `${_.get(object, 'object_square_m') || 0} m²`,
      vignet_type: selectedObjectName,
      total: `${_.get(costs, 'cost') || 0} €`,
    },
    isloading,
    objectData: {
      object_type: selectedObjectType,
      object_square_m: _.get(object, 'object_square_m'),
      line_id: state.map.lineId
    },
    selectedObjectName,
    documents: costs && costs.documents,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCosts: (payload) => {
      dispatch(Creators.fetchCosts(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetCosts);

